import { useCallback, useEffect, useState } from "react";
import { Toast } from "primereact/toast";
import { Group } from "../../../types/group";
import { getAllGroups } from "../../../services/groups";

const showToast = (
  toastRef: React.RefObject<Toast>,
  severity: "success" | "error" | "warn" | "info",
  summary: string,
  detail: string,
  life = 4000,
) => {
  toastRef.current?.show({ severity, summary, detail, life });
};

export function useGroups(toastRef: React.RefObject<Toast>) {
  const [groups, setGroups] = useState<Group[]>([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const fetchGroups = useCallback(async () => {
    const firstLoad = initialLoading;
    if (!firstLoad) setRefreshing(true);
    try {
      const data = await getAllGroups();
      setGroups(data);
    } catch (e: any) {
      const msg = e?.response?.data?.error ?? "Failed to load groups.";
      showToast(toastRef, "error", "Error", msg);
    } finally {
      if (firstLoad) setInitialLoading(false);
      else setRefreshing(false);
    }
  }, [initialLoading, toastRef]);

  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { groups, initialLoading, refreshing, fetchGroups };
}
